import React, { Component } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Form } from "formsy-react";
import styled from "styled-components";
import { Button, DatePicker } from "advenio-components";
import ReceiptActions from "../../Data/Redux/ReceiptReportRedux";
import {
  ReportHeader,
  ReportContainer,
} from "../../Components/ReportsComponents";
import { isNil } from "ramda";
import { stringContainsExactlyOf } from "../../utils/Utils";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${(props) => (props["large"] ? "row" : "column")};
  padding: 16px;
  width: ${(props) => (props.large ? "648px" : "400px")};
`;

const DatesContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

class ReceiptReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      start_date: null,
      end_date: null,
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

   onChange = (model) => {
    this.setState({ start_date: model.start_date, end_date: model.end_date })
  }


  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  download = () => {
    const { start_date, end_date} = this.state;
    const {
      activeCenter,
      fromCenter,
      getCentersReceiptReportExcel,
      getReceiptReportExcel,
      user,
    } = this.props;

     if(start_date === null  || end_date === null){
      return false
    }
    if (fromCenter) {
      let centerId;
      centerId = activeCenter;
      getCentersReceiptReportExcel(start_date, end_date, centerId);
    } else if (
      stringContainsExactlyOf(user.role, [
        "Director",
        "Nurse",
        "Coordinator",
        "Receptionist",
        "Teacher",
      ])
    ) {
      let centerId;
      centerId = user.center_id;
      getCentersReceiptReportExcel(start_date, end_date, centerId);
    } else {
      getReceiptReportExcel(start_date, end_date);
    }
  };

  render() {
    const { width } = this.state;
    const { loading } = this.props;
    return (
      <ReportContainer>
        <ReportHeader>
          <span>Reporte de Cargos Sin Recibo</span>
        </ReportHeader>
        <Form onChange={this.onChange}>
          <Container large={width > 768}>
            <DatesContainer>
              <DatePicker name="start_date" label="Fecha inicio" />
              <DatePicker name="end_date" label="Fecha Fin" />
            </DatesContainer>
            <Button
              marginRight="0"
              marginLeft="0"
              danger
              small
              onClick={this.download}
              loading={loading}
            >
              Descargar
            </Button>
          </Container>
        </Form>
      </ReportContainer>
    );
  }
}

const mapStateToProps = ({ centersInfo, auth, receiptreport }) => ({
  activeCenter: centersInfo.center,
  user: auth.user,
  loading: receiptreport.sending.fetching,
});

const mapDispatchToProps = (dispatch) => ({
  getReceiptReportExcel: (start_date, end_date) => dispatch(ReceiptActions.ReceiptReportRequest(start_date, end_date)),
  getCentersReceiptReportExcel: (start_date, end_date,id) =>
    dispatch(ReceiptActions.CentersReceiptReportRequest(start_date, end_date,id)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReceiptReport),
);



// WEBPACK FOOTER //
// ./src/Containers/Reports/Receipt.jsx